import { useMemo } from 'react';
import { useOrganization } from '@context/OrganizationContext';
import { usePermissions } from '@hooks/usePermissions';

import config from '../config';
import { useApp } from '../context/AppContext';

export default function useOrganizationAccess() {
  const { userIsFetched } = useApp();
  const { isAdmin } = usePermissions();
  const { organization, isFetched } = useOrganization();

  return useMemo(() => {
    return {
      isLoaded: isFetched && userIsFetched,
      hasAccess:
        (isFetched &&
          organization.features?.includes(config.features.organizations)) ||
        (userIsFetched && isAdmin),
    };
  }, [isFetched, userIsFetched, organization.features, isAdmin]);
}
